import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import LocationsState from '../../types/LocationsState'

export const locationsModule: Module<LocationsState, RootState> = {
  namespaced: true,
  state: {
    locations: [],
    current_location: null
  },
  getters,
  actions,
  mutations
}
